import React from "react";
import { useSite } from "@/context/SiteContext";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileBar from "@/components/layout/MobileBar";
import ChatWidget from "@/components/ChatWidget";
import ExhibitionPopup from "@/components/ExhibitionPopup";
import { WhatsAppIcon } from "@/components/BrandIcons";
import { track } from "@/lib/track";

function WhatsAppFab() {
  const site = useSite();
  const s = (site && site.site) || {};
  const wa = (s.whatsapp_number || "919924405739").replace(/[^\d]/g, "");
  return (
    <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_click")}
      className="hidden sm:flex fixed right-5 z-40 items-center justify-center rounded-full shadow-lg hover:scale-105 transition-transform"
      style={{ bottom: 90, width: 52, height: 52, background: "#25D366", color: "#fff" }}
      aria-label="Chat on WhatsApp" data-testid="desktop-whatsapp-fab">
      <WhatsAppIcon size={28} color="#fff" />
    </a>
  );
}

export default function Layout({ children }) {
  return (
    <div className="App" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <AnnouncementBar />
      <Header />
      <main className="pb-14 sm:pb-0">{children}</main>
      <Footer />
      <MobileBar />
      <WhatsAppFab />
      <ChatWidget />
      <ExhibitionPopup />
    </div>
  );
}
